module.exports = __webpack_public_path__ + "static/vo-c8078afe9814ab697ef40ef84b3da8a3.mp3";